import { render, staticRenderFns } from "./ItemTypeComponent.vue?vue&type=template&id=7b942dac&"
import script from "./ItemTypeComponent.vue?vue&type=script&lang=js&"
export * from "./ItemTypeComponent.vue?vue&type=script&lang=js&"
import style0 from "./ItemTypeComponent.vue?vue&type=style&index=0&id=7b942dac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports